import ucwords from 'locutus/php/strings/ucwords';
import ucfirst from 'locutus/php/strings/ucfirst';

export default {
    ucwords,
    ucfirst,
    lang(name) {
        return window.language[name] || '';
    },
    image(name) {
        return window.images[name] || '';
    },
    constant(name) {
        return window.constant[name] ? window.constant[name] : undefined;
    }
}

export function displayMessage(message, type) {
    if(message === undefined || message === null || message === '') {
        return;
    }
    if(!Array.isArray(message)) {
        message = [message];
    }
    if(message.length > 0) {
        message.forEach(item => {
            window.toggleToast(item, type);
        })
    }
}